import React from "react";
import { Typography, Link, CardActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const SharedDeviceLink: React.FC = () => {
  const { t } = useTranslation();

  return (
    <CardActions>
      <Typography variant="body2" align="left" paragraph>
        <Link
          style={{ fontWeight: 400 }}
          align="center"
          underline="always"
          href="https://support.google.com/chrome/answer/95464"
          target="_blank"
          data-testid="sharedDeviceLink"
          rel="noopener"
        >
          {t("login.sharedDevice")}
        </Link>
      </Typography>
    </CardActions>
  );
};

export default SharedDeviceLink;
